export const SEARCH_URL = {
  SEARCH: "/search/apis/search/unrestricted",
  REGION: "/hospital/apis/search/unrestricted/categories/region",
  TREATMENT: (modal: boolean) => `/hospital/apis/search/unrestricted/categories/treatment?modal=${modal}`,
  AUTO_COMPLETE: "/search/apis/search/unrestricted/auto-complete",
}
